(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-finish-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wc-product-finish-gallery')) {
  customElements.define('wc-product-finish-gallery', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.zoomRequest = (this.zoomRequest || 0) + 1;
      this.events?.abort();
      const dialog = this.querySelector('dialog');
      if (dialog?.open) dialog.close();
    }
    setup() {
      this.events?.abort();
      this.zoomRequest = (this.zoomRequest || 0) + 1;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const tabs = [...this.querySelectorAll('[data-pfg-tab]')];
      const panels = [...this.querySelectorAll('[data-pfg-panel]')];
      const select = (tab, focus = false) => {
        if (!tab) return;
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
      };
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-pfg-tab]');
        if (tab) select(tab);
      }, options);
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-pfg-tab]');
        if (!tab || !tabs.includes(tab)) return;
        let index = tabs.indexOf(tab);
        const rtl = getComputedStyle(this).direction === 'rtl';
        if (event.key === 'ArrowRight') index += rtl ? -1 : 1;
        else if (event.key === 'ArrowLeft') index += rtl ? 1 : -1;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else return;
        event.preventDefault();
        select(tabs[(index + tabs.length) % tabs.length], true);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        select(tabs.find(tab => tab.dataset.blockId === event.detail?.blockId));
      }, options);
      const dialog = this.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      let opener;
      let slides = [];
      let slideIndex = 0;
      const stage = dialog.querySelector('[data-pfg-stage]');
      const showSlide = async index => {
        if (!slides.length) return;
        const request = ++this.zoomRequest;
        slideIndex = (index + slides.length) % slides.length;
        const link = slides[slideIndex];
        const loading = document.createElement('p');
        loading.className = 'pfg-loading';
        loading.textContent = 'Loading sample…';
        stage.replaceChildren(loading); // Clear the previous pixels before opening or navigating.
        dialog.querySelector('[data-pfg-title]').textContent = link.dataset.caption || 'Wood sample';
        dialog.querySelector('[data-pfg-count]').textContent = `(${slideIndex + 1} / ${slides.length})`;
        dialog.querySelectorAll('.pfg-nav').forEach(button => { button.hidden = slides.length < 2; });
        dialog.setAttribute('aria-busy', 'true');
        const image = new Image();
        image.className = 'pfg-enlarged';
        image.alt = link.dataset.alt || link.dataset.caption || '';
        image.width = 1200;
        image.height = 1200;
        try {
          if (typeof image.decode === 'function') {
            image.src = link.href;
            await image.decode();
          } else {
            await new Promise((resolve, reject) => {
              image.onload = resolve;
              image.onerror = reject;
              image.src = link.href;
            });
          }
          if (request !== this.zoomRequest || !dialog.open || !this.isConnected) return;
          stage.replaceChildren(image); // Only the current, decoded image becomes visible.
          dialog.setAttribute('aria-busy', 'false');
        } catch (error) {
          if (request !== this.zoomRequest || !dialog.open || !this.isConnected) return;
          loading.textContent = 'This sample could not load. Close and try again.';
          dialog.setAttribute('aria-busy', 'false');
        }
      };
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-pfg-zoom]');
        if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          opener = link;
          slides = [...link.closest('.pfg-panel').querySelectorAll('[data-pfg-zoom]')];
          showSlide(slides.indexOf(link));
          if (!dialog.open) dialog.showModal();
        }
        if (event.target.closest('[data-pfg-prev]')) showSlide(slideIndex - 1);
        if (event.target.closest('[data-pfg-next]')) showSlide(slideIndex + 1);
        if (event.target.closest('[data-pfg-close]')) dialog.close();
      }, options);
      dialog.addEventListener('keydown', event => {
        if (!dialog.open || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const rtl = getComputedStyle(this).direction === 'rtl';
        showSlide(slideIndex + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
      }, options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        this.zoomRequest++;
        stage.replaceChildren();
        dialog.removeAttribute('aria-busy');
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      }, options);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wc-compact-finishes"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('wc-wood-finish-samples')){
  customElements.define('wc-wood-finish-samples',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.dialog=this.querySelector('.wfs-dialog');
      this.controller=new AbortController();
      this.zoomRequest=0;
      const options={signal:this.controller.signal};
      this.addEventListener('click',event=>{
        const wood=event.target.closest('[data-wfs-wood]');
        if(wood&&this.contains(wood))this.selectWood(wood.dataset.wfsWood);
      },options);
      this.addEventListener('keydown',event=>{
        const wood=event.target.closest('[data-wfs-wood]');
        if(!wood||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        const buttons=Array.from(this.querySelectorAll('[data-wfs-wood]'));
        const direction=getComputedStyle(this).direction==='rtl'?-1:1;
        let index=buttons.indexOf(wood);
        if(event.key==='Home')index=0;
        else if(event.key==='End')index=buttons.length-1;
        else index=(index+(event.key==='ArrowRight'?direction:-direction)+buttons.length)%buttons.length;
        event.preventDefault();buttons[index].focus();this.selectWood(buttons[index].dataset.wfsWood);
      },options);
      this.addEventListener('shopify:block:select',event=>{
        const panel=event.target.closest('[data-wfs-panel]');
        if(panel)this.selectWood(panel.dataset.wfsPanel);
      },options);
      this.classList.add('is-ready');
      this.selectWood(this.dataset.initialWood||'alder');
      this.addEventListener('click',event=>{
        const link=event.target.closest('[data-wfs-zoom]');
        if(!link||!this.contains(link)||typeof this.dialog?.showModal!=='function'||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        event.preventDefault();
        void this.openZoom(link);
      },options);
      this.querySelector('[data-wfs-prev]').addEventListener('click',()=>this.stepZoom(-1),options);
      this.querySelector('[data-wfs-next]').addEventListener('click',()=>this.stepZoom(1),options);
      this.dialog.addEventListener('keydown',event=>{
        if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.stepZoom(event.key==='ArrowRight'?1:-1);}
      },options);
      this.querySelector('[data-wfs-close]').addEventListener('click',()=>this.dialog.close(),options);
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}},options);
      this.dialog.addEventListener('close',()=>{
        this.zoomRequest++;this.querySelector('[data-wfs-stage]').replaceChildren();
        this.dialog.removeAttribute('aria-busy');
        if(this.opener?.isConnected)this.opener.focus({preventScroll:true});
      },options);
      this.querySelectorAll('[data-wfs-zoom]').forEach(link=>link.setAttribute('aria-haspopup','dialog'));
    }
    selectWood(key){
      const panels=Array.from(this.querySelectorAll('[data-wfs-panel]'));
      const active=panels.find(panel=>panel.dataset.wfsPanel===key)||panels[0];
      if(!active)return;
      panels.forEach(panel=>{panel.hidden=panel!==active;});
      this.querySelectorAll('[data-wfs-wood]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.wfsWood===active.dataset.wfsPanel)));
      this.querySelector('[data-wfs-current]').textContent=`· ${active.dataset.woodName}`;
    }
    stepZoom(direction){
      if(!this.zoomLinks?.length)return;
      this.zoomIndex=(this.zoomIndex+direction+this.zoomLinks.length)%this.zoomLinks.length;
      void this.openZoom(this.zoomLinks[this.zoomIndex],true);
    }
    async openZoom(link,navigating=false){
      const request=++this.zoomRequest;
      if(!navigating){
        this.opener=link;
        this.zoomLinks=Array.from(link.closest('[data-wfs-panel]').querySelectorAll('[data-wfs-zoom]'));
        this.zoomIndex=this.zoomLinks.indexOf(link);
      }
      const stage=this.querySelector('[data-wfs-stage]');
      const loading=document.createElement('p');loading.className='wfs-loading';loading.textContent='Loading sample…';
      stage.replaceChildren(loading); // Remove the old pixels BEFORE opening.
      this.querySelector('[data-wfs-title]').textContent=link.dataset.caption;
      this.querySelector('[data-wfs-count]').textContent=`(${this.zoomIndex+1} / ${this.zoomLinks.length})`;
      this.dialog.setAttribute('aria-busy','true');
      if(!this.dialog.open)this.dialog.showModal();
      const image=new Image();image.className='wfs-zoom-image';image.alt=link.dataset.caption;
      try{
        if(typeof image.decode==='function'){image.src=link.href;await image.decode();}
        else await new Promise((resolve,reject)=>{image.onload=resolve;image.onerror=reject;image.src=link.href;});
        if(request!==this.zoomRequest||!this.dialog.open||!this.isConnected)return;
        stage.replaceChildren(image); // Only a decoded, current image enters the dialog.
        this.dialog.setAttribute('aria-busy','false');
      }catch(error){
        if(request!==this.zoomRequest||!this.dialog.open)return;
        loading.textContent='This sample could not load. Close and try again.';
        this.dialog.setAttribute('aria-busy','false');
      }
    }
    disconnectedCallback(){
      this.zoomRequest++;
      if(this.dialog?.open)this.dialog.close();
      this.controller?.abort();
      this.controller=null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
